module.exports = __webpack_public_path__ + "static/media/eye.cde8cf61.svg";